import React from "react";
import AppBar from "@mui/material/AppBar";
import ToolbarMui from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import ListItemText from "@mui/material/ListItemText";
import CircularProgress from '@mui/material/CircularProgress';

import {AVATAR_BASE_URL_API, BANNER_BASE_URL_API, BASE_URL_API, PRODUCT_BASE_URL_API} from "../Const";
import {BasketComponent} from "./BasketComponent";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import {Link} from "react-router-dom";
import Paper from "@mui/material/Paper";
import {ProductStructList} from "../structs/ProductStructList";
import {ProductStruct} from "../structs/ProductStruct";
import Box from "@mui/material/Box";
import {MarketStructList} from "../structs/MarketStructList";
import {MarketStruct} from "../structs/MarketStruct";
import Typography from "@mui/material/Typography";
import {styled} from "@mui/material/styles";
import AliceCarousel from "react-alice-carousel";
import MenuIcon from "@mui/icons-material/Menu";
import Drawer from "@mui/material/Drawer";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import {Grid} from "@mui/material";
import AvatarIcon from "../assets/icons/avatar.svg";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import AddCardIcon from "@mui/icons-material/AddCard";
import Divider from "@mui/material/Divider";
import ListItemIcon from "@mui/material/ListItemIcon";
import PendingActionsOutlinedIcon from "@mui/icons-material/PendingActionsOutlined";
import ShoppingBasketOutlinedIcon from "@mui/icons-material/ShoppingBasketOutlined";
import ReduceCapacityOutlinedIcon from "@mui/icons-material/ReduceCapacityOutlined";
import PrivacyTipOutlinedIcon from "@mui/icons-material/PrivacyTipOutlined";
import SearchIcon from "@mui/icons-material/Search";
import {BottomMenu} from './HookUtils'
import Inventory2Icon from "@mui/icons-material/Inventory2";
import Chip from "@mui/material/Chip";
import LoadingSplash from "./commoncComponent/LoadingSplash";

const items = [
    <div className="item" data-value="1">
        1
    </div>,
    <div className="item" data-value="2">
        2
    </div>,
    <div className="item" data-value="3">
        3
    </div>,
    <div className="item" data-value="4">
        4
    </div>,
    <div className="item" data-value="5">
        5
    </div>,
];

const drawerWidth = 240;
const DrawerHeader = styled('div')(({theme}) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-start',
}));


export class OfferComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            searchResultProduct: [],
            searchResultMarket: [],
            banners: [],
            value: 0,
            userData: null,
            open: false,
            isLoading: true,
            loadingVisible: true,
        }

        this.loadingRef = React.createRef();
    }


    componentDidMount() {
        fetch(BASE_URL_API + 'search?q=', {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem("pwa_token"),
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(results => {

                    if (results.code === 200) {
                        let data = new ProductStructList();

                        for (let i = 0; i < results.data.products.length; i++) {
                            if (data.productList.length > 0) {
                                let size = data.productList.length;
                                for (let j = 0; j < size; j++) {
                                    if (results.data.products[i].category !== null && data.productList[j].category === results.data.products[i].category.title) {
                                        data.productList[j].productList.push(results.data.products[i])

                                        break
                                    } else {
                                        if (j === data.productList.length - 1) {
                                            if (results.data.products[i].category != null) {
                                                let productStruct = new ProductStruct()
                                                productStruct.category = results.data.products[i].category.title
                                                productStruct.productList.push(results.data.products[i])
                                                data.productList.push(productStruct)
                                            }
                                        }
                                    }
                                }
                            } else {
                                if (results.data.products[i].category != null) {
                                    let productStruct = new ProductStruct()
                                    productStruct.category = results.data.products[i].category.title
                                    productStruct.productList.push(results.data.products[i])
                                    data.productList.push(productStruct)
                                }

                            }


                        }

                        let marketData = new MarketStructList();

                        for (let i = 0; i < results.data.markets.length; i++) {
                            if (marketData.marketList.length > 0) {
                                let size = marketData.marketList.length;
                                for (let j = 0; j < size; j++) {
                                    if (results.data.markets[i].category !== null && marketData.marketList[j].category === results.data.markets[i].category.title) {
                                        marketData.marketList[j].marketList.push(results.data.markets[i])

                                        break
                                    } else {
                                        if (j === marketData.marketList.length - 1) {
                                            let marketStruct = new MarketStruct()
                                            marketStruct.category = results.data.markets[i].category.title
                                            marketStruct.marketList.push(results.data.markets[i])
                                            marketData.marketList.push(marketStruct)

                                        }
                                    }
                                }
                            } else {
                                let marketStruct = new MarketStruct()
                                marketStruct.category = results.data.markets[i].category.title
                                marketStruct.marketList.push(results.data.markets[i])
                                marketData.marketList.push(marketStruct)
                            }


                        }


                        const offerList = data.productList.filter(function (item) {
                            return item.category.indexOf('داغ') !== -1
                        });

                        let difference = data.productList.filter(x => !offerList.includes(x));


                        var finalList = offerList.concat(bubbleSort(difference, difference.length))

                        this.setState({
                            searchResultProduct: finalList
                            , searchResultMarket: marketData.marketList
                        })

                        this.setState({isLoading: false})

                        this.loadingRef.current?.hide();
                        this.setState({ loadingVisible: false });
                    }

                },
                (error) => {
                    console.log(error)

                    this.loadingRef.current?.hide();
                    this.setState({ loadingVisible: false });
                }
            );

        fetch(BASE_URL_API + 'banner?type=home')
            .then(response => response.json())
            .then(results => {
                    this.setState({banners: results.data})

                },
                (error) => {
                    console.log("error")

                }
            );

        fetch(BASE_URL_API + 'user', {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem("pwa_token"),
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(results => {
                    if (results.code === "200") {
                        this.setState({userData: results.data})
                    }


                },
                (error) => {
                    console.log("error")

                }
            );

        function bubbleSort(arr, n) {
            var i, j, temp;
            var swapped;
            for (i = 0; i < n - 1; i++) {
                for (j = 0; j < n - i - 1; j++) {
                    if (arr[j].productList.length < arr[j + 1].productList.length) {
                        // Swap arr[j] and arr[j+1]
                        temp = arr[j];
                        arr[j] = arr[j + 1];
                        arr[j + 1] = temp;
                        swapped = true;
                    }
                }

                // IF no two elements were
                // swapped by inner loop, then break
            }

            return arr
        }

        this.loadingRef.current?.show("درحال بارگزاری محصولات...");

    }

    handleChange = (event, newValue) => {
        this.setState({value: newValue})
    };

    handleDrawerClose = () => {
        this.setState({open: false})
    };

    handleDrawerOpen = () => {
        this.setState({open: true})
    };

    render() {

        const { loadingVisible } = this.state;

        let drawerOptionLinks = ['/transaction', '/order', "/about-us", "/privacy-policy"];

        const flexContainer = {
            display: 'flex',
            flexDirection: 'row',
            overflowX: 'auto',
            overflowY: 'hidden',
            height: 290,
            background: 'rgba(238,238,238,0.3)',
            align: 'right'
        };

        const MAX_LENGTH = 25;

        // Helpers (put near the component)
        const formatStep = (val) => {
            const num = Number(val);
            if (!isFinite(num) || num <= 0) return "";
            return parseFloat(num.toFixed(4)).toLocaleString("en", {maximumFractionDigits: 4});
        };

        const formatTomans = (val) =>
            Number(val || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " تومان ";


// JSX

        return (
            <>
                {/* Splash is mounted once and controlled imperatively */}
                <LoadingSplash ref={this.loadingRef}/>

                {/* Only render the main UI after splash hides */}
                {!loadingVisible && (
                    <React.Fragment>
                        <AppBar elevation={0}
                                sx={{background: "rgba(238,238,238,0.3)", backdropFilter: "blur(6px)"}}>
                            <ToolbarMui>
                                <IconButton
                                    color="inherit"
                                    aria-label="open drawer"
                                    edge="end"
                                    onClick={this.handleDrawerOpen}
                                    sx={{...(this.state.open && {display: 'none'})}}
                                    size="large">
                                    <MenuIcon style={{color: 'black'}}/>

                                </IconButton>

                                <ListItemText align="center"><strong style={{
                                    width: '90%',
                                    fontSize: 18,
                                    overflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    color: 'black'
                                }}>{"Hamekara"}</strong></ListItemText>

                                <IconButton component={Link} to={"/search"} style={{color: 'black'}}
                                            size="large"><SearchIcon/></IconButton>

                                <IconButton style={{color: 'black'}} size="large"> <BasketComponent/></IconButton>

                            </ToolbarMui>

                        </AppBar>
                        <Drawer
                            anchor="left"
                            open={this.state.open}
                            onClose={this.handleDrawerClose}
                            sx={{
                                '& .MuiDrawer-paper': {
                                    width: drawerWidth,
                                    direction: 'rtl', // ✅ reinforce direction
                                    right: 0,
                                    left: 'auto',
                                },
                            }}
                        >

                            <DrawerHeader>
                                <IconButton onClick={this.handleDrawerClose} size="large">
                                    <ChevronRightIcon/>
                                </IconButton>
                                {
                                    (this.state.userData === null || this.state.userData.picture === null) ?
                                        (<Grid container>
                                            <Grid xs={12}>
                                                <img style={{marginRight: 16}} alt="avatar2" src={AvatarIcon}/>
                                                {
                                                    this.state.userData !== null ? <Typography style={{
                                                        fontWeight: 'bold',
                                                        fontSize: 18,
                                                        marginBottom: 18,
                                                        marginRight: 16,
                                                        color: 'green',
                                                    }}>{this.state.userData.name}</Typography> : ""
                                                }

                                            </Grid>

                                            {
                                                this.state.userData !== null ?
                                                    <React.Fragment>
                                                        <Grid xs={2}>
                                                            <PhoneIphoneIcon/>
                                                        </Grid>
                                                        <Grid xs={10}>

                                                            <Typography key={this.state.userData.phone} style={{
                                                                fontSize: 14,
                                                                color: 'gray',
                                                            }} align='right'>{this.state.userData.phone}
                                                            </Typography>
                                                        </Grid>

                                                        <Grid xs={2}>
                                                            <AddCardIcon/>
                                                        </Grid>
                                                        <Grid xs={10}>

                                                            <Typography key={this.state.userData.wallet} style={{
                                                                fontSize: 14,
                                                                color: 'gray'
                                                            }} align='right'>
                                                                {this.state.userData.wallet}
                                                            </Typography>

                                                        </Grid>
                                                    </React.Fragment>
                                                    : ""

                                            }

                                        </Grid>) : (
                                            <Grid container>
                                                <Grid xs={12}>
                                                    <img style={{marginRight: 16}} alt="avatar2"
                                                         src={`${AVATAR_BASE_URL_API}${this.state.userData.picture.url}`}/>
                                                    <Typography style={{
                                                        fontWeight: 'bold',
                                                        fontSize: 18,
                                                        marginBottom: 18,
                                                        marginRight: 16,
                                                        color: 'green',
                                                    }}>{this.state.userData.name}</Typography>
                                                </Grid>

                                                <Grid xs={2}>
                                                    <PhoneIphoneIcon/>
                                                </Grid>
                                                <Grid xs={10}>

                                                    <Typography key={this.state.userData.phone} style={{
                                                        fontSize: 14,
                                                        color: 'gray',
                                                    }} align='right'>{this.state.userData.phone}
                                                    </Typography>
                                                </Grid>

                                                <Grid xs={2}>
                                                    <AddCardIcon/>
                                                </Grid>
                                                <Grid xs={10}>

                                                    <Typography key={this.state.userData.wallet} style={{
                                                        fontSize: 14,
                                                        color: 'gray'
                                                    }} align='right'>
                                                        {this.state.userData.wallet}
                                                    </Typography>

                                                </Grid>


                                            </Grid>
                                        )

                                }


                            </DrawerHeader>

                            <Divider style={{marginTop: 50}}/>


                            <List>
                                {['سوابق تراکنش', 'سفارشات', 'درباره ما', 'قوانین و مقررات'].map((text, index) => (
                                    <ListItem button key={text} component={Link}
                                              to={drawerOptionLinks[index]}>
                                        <ListItemIcon>
                                            {index === 0 ? <PendingActionsOutlinedIcon/> : ""}
                                            {index === 1 ? <ShoppingBasketOutlinedIcon/> : ""}
                                            {index === 2 ? <ReduceCapacityOutlinedIcon/> : ""}
                                            {index === 3 ? <PrivacyTipOutlinedIcon/> : ""}
                                        </ListItemIcon>
                                        <ListItemText align='right'>{text}</ListItemText>
                                    </ListItem>
                                ))}
                            </List>

                            <Divider/>

                        </Drawer>
                        <AliceCarousel autoPlay
                                       autoPlayStrategy="none"
                                       autoPlayInterval={2500}
                                       animationDuration={1000}
                                       infinite
                                       touchTracking={false}
                                       disableButtonsControls
                                       disableDotsControls
                                       items={items}>

                            {this.state.banners.map((banner, index) => (
                                <div align='center'>
                                    <img style={{marginTop: 55, width: '100%', objectFit: 'contain'}}
                                         src={(BANNER_BASE_URL_API + banner.picture.url)}/>
                                </div>

                            ))}
                        </AliceCarousel>
                        <Box>
                            <div align='center'>
                                {this.state.isLoading === true ? (
                                    <CircularProgress style={{
                                        align: 'center'
                                    }}/>
                                ) : ''}

                            </div>


                            {
                                this.state.searchResultProduct.map((product) => (
                                    <Box
                                        key={product.id}
                                        sx={{
                                            position: "relative",
                                            overflow: "hidden",
                                            borderRadius: 2,
                                            border: (t) => `1px solid ${t.palette.divider}`,
                                            pt: 5,              // space for the hanging tab
                                            p: 1.5,
                                            mb: 2,
                                        }}
                                    >

                                        {/* 🔖 Bookmark / Anchor tab */}
                                        {product.category && (
                                            <Box
                                                sx={{
                                                    position: "absolute",
                                                    top: 0,
                                                    insetInlineStart: 16,     // RTL-friendly "left"
                                                    transform: "translateY(-1px)", // tucks into border nicely
                                                    zIndex: 2,
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    px: 1.25,
                                                    height: 34,
                                                    bgcolor: "#FF1744",
                                                    color: "#fff",
                                                    fontSize: 14,
                                                    fontWeight: 700,
                                                    borderRadius: "0 0 14px 14px",  // 👈 curved bottom
                                                    boxShadow: "0 2px 6px rgba(0,0,0,0.12)",
                                                    lineHeight: 1,
                                                    userSelect: "none",
                                                    "&::after": {
                                                        // subtle curved lip shadow under the tab for realism
                                                        content: '""',
                                                        position: "absolute",
                                                        bottom: -1,
                                                        left: 6,
                                                        right: 6,
                                                        height: 6,
                                                        borderRadius: "0 0 10px 10px",
                                                        background: "rgba(0,0,0,0.06)",
                                                        filter: "blur(2px)",
                                                        pointerEvents: "none",
                                                    },
                                                }}
                                                title={product.category}
                                            >
                                                {product.category}
                                            </Box>
                                        )}


                                        <List
                                            key={product.id}
                                            style={flexContainer} // keep your original container behavior
                                            sx={{
                                                px: 1,
                                                gap: 1.5,
                                            }}
                                        >
                                            {product.productList.map((product) => (
                                                <ListItem
                                                    key={product.id}
                                                    component={Link}
                                                    to={"/product?id=" + product.id}
                                                    sx={{
                                                        width: 250,
                                                        px: 0,
                                                        textDecoration: "none",
                                                        color: "inherit",
                                                    }}
                                                >
                                                    <Paper
                                                        elevation={1}
                                                        sx={{
                                                            width: "100%",
                                                            height: "100%",
                                                            borderRadius: 2,
                                                            p: 1.25,
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            gap: 1,
                                                            transition: "transform 120ms ease, box-shadow 120ms ease",
                                                            "&:hover": {
                                                                transform: "translateY(-2px)",
                                                                boxShadow: 3,
                                                            },
                                                        }}
                                                    >
                                                        {/* Image */}
                                                        <Box
                                                            sx={{
                                                                width: 140,
                                                                height: 140,
                                                                borderRadius: 1.5,
                                                                overflow: "hidden",
                                                                bgcolor: "#ffffff",
                                                                display: "flex",               // ✅ enables flexbox
                                                                alignItems: "center",          // ✅ vertical centering
                                                                justifyContent: "center",      // ✅ horizontal centering
                                                            }}
                                                        >
                                                            <Box
                                                                component="img"
                                                                alt={product.title}
                                                                src={
                                                                    product.pictures.length > 0
                                                                        ? PRODUCT_BASE_URL_API + product.pictures[0].url
                                                                        : "hamekara-logo.png"
                                                                }
                                                                sx={{
                                                                    maxWidth: "100%",            // ✅ prevents overflow
                                                                    maxHeight: "100%",           // ✅ keeps proportions
                                                                    objectFit: "contain",        // ✅ avoids deformation
                                                                    display: "block",
                                                                }}
                                                            />
                                                        </Box>


                                                        {/* Title */}
                                                        <Typography
                                                            variant="body2"
                                                            sx={{
                                                                fontWeight: 700,
                                                                color: "text.primary",
                                                                whiteSpace: "nowrap",
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                                direction: "rtl",
                                                            }}
                                                            title={product.title}
                                                        >
                                                            {product.title.length > MAX_LENGTH
                                                                ? `${product.title.substring(0, MAX_LENGTH)}...`
                                                                : product.title}
                                                        </Typography>

                                                        {/* Inventory / تماس بگیرید */}
                                                        <Typography
                                                            variant="caption"
                                                            sx={{
                                                                lineHeight: 1.2,
                                                                color: Number(product.step) > 0 ? "text.secondary" : "error.main",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                gap: 0.5,
                                                                whiteSpace: "nowrap",
                                                                direction: "rtl",
                                                            }}
                                                        >
                                                            {Number(product.step) > 0 ? (
                                                                <>
                                                                    <Inventory2Icon fontSize="inherit"/>
                                                                    موجودی:&nbsp;{formatStep(product.step)}
                                                                </>
                                                            ) : (
                                                                "تماس بگیرید"
                                                            )}
                                                        </Typography>

                                                        {product.markets?.name && (
                                                            <Chip
                                                                label={product.markets.name}
                                                                size="small"
                                                                sx={{
                                                                    display: "inline-flex",     // ✅ don't stretch full width
                                                                    width: "fit-content",       // ✅ shrink to text
                                                                    direction: "rtl",
                                                                    fontSize: 11,
                                                                    height: 22,
                                                                    borderRadius: 1,
                                                                    px: 0.8,
                                                                    bgcolor: "grey.100",
                                                                    color: "text.secondary",
                                                                    "& .MuiChip-label": {
                                                                        whiteSpace: "nowrap",
                                                                        overflow: "hidden",
                                                                        textOverflow: "ellipsis",
                                                                        px: 0.5,
                                                                    },
                                                                }}
                                                                title={product.markets.name}
                                                            />
                                                        )}


                                                        {/* Price / Discount */}
                                                        {Number(product.del_price) > 0 ? (
                                                            <Box sx={{mt: "auto"}}>
                                                                <Typography
                                                                    variant="body2"
                                                                    sx={{
                                                                        color: "text.secondary",
                                                                        textDecoration: "line-through",
                                                                        whiteSpace: "nowrap",
                                                                        direction: "rtl",
                                                                    }}
                                                                >
                                                                    <strong>{formatTomans(product.price)}</strong>
                                                                </Typography>

                                                                <Typography
                                                                    variant="body1"
                                                                    sx={{
                                                                        color: "success.main",
                                                                        fontWeight: 700,
                                                                        whiteSpace: "nowrap",
                                                                        direction: "rtl",
                                                                    }}
                                                                >
                                                                    <strong>
                                                                        {formatTomans(
                                                                            parseInt(product.price, 10) - parseInt(product.del_price, 10)
                                                                        )}
                                                                    </strong>
                                                                </Typography>
                                                            </Box>
                                                        ) : (
                                                            <Box sx={{mt: "auto"}}>
                                                                <Typography
                                                                    variant="body1"
                                                                    sx={{
                                                                        color: Number(product.price) > 0 ? "success.main" : "warning.main",
                                                                        fontWeight: 700,
                                                                        whiteSpace: "nowrap",
                                                                        direction: "rtl",
                                                                    }}
                                                                >
                                                                    <strong>
                                                                        {Number(product.price) > 0
                                                                            ? formatTomans(product.price)
                                                                            : "تماس بگیرید."}
                                                                    </strong>
                                                                </Typography>
                                                            </Box>
                                                        )}
                                                    </Paper>
                                                </ListItem>
                                            ))}
                                        </List>
                                    </Box>

                                ))

                            }
                        </Box>
                        <BottomMenu/>

                        <Box
                            component="footer"
                            sx={{
                                backgroundColor: '#1e1e1e',
                                color: '#f1f1f1',
                                px: 3,
                                py: 4,
                                mt: 6,
                                fontSize: 14,
                                pb: "70px",
                                textAlign: 'center'
                            }}
                        >
                            <Grid container spacing={3} justifyContent="center">
                                <Grid item xs={12} sm={4}>
                                    <Typography variant="h6" sx={{fontWeight: 'bold', mb: 1}}>
                                        درباره همه کارا
                                    </Typography>
                                    <Typography variant="body2" sx={{mb: 1}}>
                                        سامانه فروشگاهی <strong>همه کارا</strong> راهکاری نوین برای مدیریت فروشگاه‌های
                                        آنلاین و
                                        آفلاین است. با امکانات ثبت سفارش، باشگاه مشتریان، گزارش‌ گیری مالی و پشتیبانی.
                                    </Typography>
                                    <a
                                        href="https://intro.hamekara.com/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{color: '#4fc3f7', textDecoration: 'none', fontWeight: 'bold'}}
                                    >
                                        معرفی کامل همه کارا
                                    </a>
                                </Grid>

                                <Grid item xs={12} sm={4}>
                                    <Typography variant="h6" sx={{fontWeight: 'bold', mb: 1}}>
                                        تماس با ما
                                    </Typography>
                                    <Typography variant="body2" sx={{mb: 0.5}}>📞 0383-228-5853</Typography>
                                    <Typography variant="body2" sx={{mb: 0.5}}>📧 thetoptraders@gmail.com</Typography>
                                    <Typography variant="body2"> 📍 ایران - شهرکرد - ساختمان علم و فناوری پردیس - طبقه
                                        سوم -
                                        واحد 305</Typography>
                                </Grid>

                                <Grid item xs={12} sm={4}
                                      sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>

                                    <div className="trust-badge">
                                        <a
                                            referrerPolicy="origin"
                                            target="_blank"
                                            href="https://trustseal.enamad.ir/?id=618220&Code=W86FGXOVhlD2RNWlNLWwxE5EVujECL5N"
                                        >
                                            <img
                                                referrerPolicy="origin"
                                                src="https://trustseal.enamad.ir/logo.aspx?id=618220&Code=W86FGXOVhlD2RNWlNLWwxE5EVujECL5N"
                                                alt=""
                                                style={{cursor: "pointer"}}
                                                code="W86FGXOVhlD2RNWlNLWwxE5EVujECL5N"
                                            />
                                        </a>
                                    </div>
                                </Grid>
                            </Grid>

                            <Divider sx={{my: 3, bgcolor: '#555'}}/>

                            <Typography variant="caption" sx={{color: '#aaa'}}>
                                © {new Date().getFullYear()} Hamekara.com - کلیه حقوق محفوظ است
                            </Typography>
                        </Box>
                    </React.Fragment>
                )}
            </>
        );

    }
}
